import Codelist from "@/Modules/Codelist/Resources/Codelist"

export default {
  created () {
    this.$api.register({ Codelist }, this._uid)
  }
}
